import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _SIZE_TO_VAL;
// Keep adding the sizes here as it when it comes in future.

// These are kept same as the ones in tmatter.
var MEDIUM = 'medium';
var SMALL = 'small';
var LARGE = 'large';
export var SIZE_TO_VAL = (_SIZE_TO_VAL = {}, _defineProperty(_SIZE_TO_VAL, SMALL, '4px'), _defineProperty(_SIZE_TO_VAL, MEDIUM, '6px'), _defineProperty(_SIZE_TO_VAL, LARGE, '8px'), _SIZE_TO_VAL);
export var SIZES = {
  SMALL: SMALL,
  MEDIUM: MEDIUM,
  LARGE: LARGE
};